import React, { useState, useEffect } from "react";
import { GET_USER_BY_ROLES, UPDATE_UNLOADER_MAPPING, GET_APPROVED_STAKEHOLDERS, WEIGHBRIDGE_ID_LIST } from '../../common/URLs';
import { toast } from 'react-toastify';
import { loaderService } from "../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../common/localStorageUtils";
import { Fab, Typography, Container, Card, CardContent, Box, Grid, TextField, Button, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { ConfirmationPopover } from "../../common/commonPopovers/confirmationPopover";
import { useLocation, useNavigate } from 'react-router-dom';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import { SubmitIcon } from "../../common/icons";
import apiClient from "../../axios";

export function WBOUnloaderMapping() {

    const data = useLocation().state?.selectedRow;
    const navigate = useNavigate();
    const [urnList, setUrnList] = useState();
    const [stakeholderType, setStakeholderType] = useState('');
    const [stakeholderUrn, setStakeholderUrn] = useState('');
    const [mappedUserEmailId, setMappedUserEmailId] = useState('');
    const [mappedUserRoleName, setMappedUserRoleName] = useState('');
    const [unloadersList, setUnloadersList] = useState();
    const [weighbridgeIdList, setWeighbridgeIdList] = useState();
    const [weighbridgeId, setWeighbridgeId] = useState('');
    const [getMappingResponse, setGetMappingResponse] = useState();

    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);
    const [isApiCalled, setIsApiCalled] = useState(false);

    const [errorMessage, setErrorMessage] = useState({
        "stakeholderTypeError": "",
        "stakeholderUrnError": "",
        "mappedUserEmailIdError": '',
        "mappedUserRoleNameError": "",
        "weighbridgeIdError": "",
    });

    useEffect(() => {
        if (data) {
            setStakeholderType(data.stakeholderType);
            setStakeholderUrn(data.stakeholderUrn);
            setMappedUserEmailId(data.mappedUserEmailId);
            setMappedUserRoleName(data.mappedUserRoleName);
            setWeighbridgeId(data.weighbridgeId);
        }
    }, [data]);

    useEffect(() => {
        if (mappedUserRoleName) {
            getAllUnloaders();
            getAllWeighbridgeIds();
        }
    }, [mappedUserRoleName]);

    function getAllUnloaders() {
        loaderService.showLoader();
        apiClient
            .post(GET_USER_BY_ROLES,
                {
                    "roleName": mappedUserRoleName
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setUnloadersList(response.data.users);
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
            });
    }

    useEffect(() => {
        if (stakeholderType) {
            onStakeholderTypeChange();
        }
    }, [stakeholderType]);

    const onStakeholderTypeChange = () => {
        loaderService.showLoader();
        apiClient.post(GET_APPROVED_STAKEHOLDERS,
            {
                "type": stakeholderType
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setUrnList(response.data.stakeHolders);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const getAllWeighbridgeIds = () => {
        loaderService.showLoader();
        apiClient.post(WEIGHBRIDGE_ID_LIST,
            {
            },
            {
                headers: {
                    Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    "Content-Type": "application/json"
                }
            })
            .then((response) => {
                setWeighbridgeIdList(response.data.weighbridgeIdList);
                loaderService.hideLoader();

            }).catch(function (error) {
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }


    const handleMappedRoleChange = (e) => {
        setMappedUserRoleName(e.target.value);
        setErrorMessage({ ...errorMessage, mappedUserRoleNameError: "" });
    };

    const handleMappedUserEmailChange = (e) => {
        setMappedUserEmailId(e.target.value);
        setErrorMessage({ ...errorMessage, mappedUserEmailIdError: "" });
    };

    const onTypeChange = (e) => {
        setStakeholderType(e.target.value);
        setErrorMessage({ ...errorMessage, stakeholderTypeError: "" });
    }

    const onUrnChange = (e) => {
        setStakeholderUrn(e.target.value);
        setErrorMessage({ ...errorMessage, stakeholderUrnError: "" });
    }

    const onWeighBridgeIdChange = (e) => {
        setWeighbridgeId(e.target.value);
        setErrorMessage({ ...errorMessage, weighbridgeIdError: "" });
    }

    // const onConfirmSubmit = (e) => {
    //     handleLogModalClose();
    //     updateMapping(e);
    // }

   
 
    const onConfirmSubmit = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await updateMapping();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setLogModalOpen(false);
            setIsApiCalled(false);
        }
    };

    const onSubmitButtonClick = (e) => {
        handleLogModalOpen();
    }

    const onSubmit = (e) => {
        if (!stakeholderType) {
            setErrorMessage({ ...errorMessage, stakeholderTypeError: "Please Select Stakeholder Type" })
        }
        else if (!stakeholderUrn) {
            setErrorMessage({ ...errorMessage, stakeholderUrnError: "Please Select Stakeholder URN" })
        }
        else if (!mappedUserRoleName) {
            setErrorMessage({ ...errorMessage, mappedUserRoleNameError: "Please Select User Role" })
        }
        else if (!mappedUserEmailId) {
            setErrorMessage({ ...errorMessage, mappedUserEmailIdError: "Please Enter User's Email ID" })
        }
        // else if (!weighbridgeId) {
        //     setErrorMessage({ ...errorMessage, weighbridgeIdError: "Please Select Weighbridge ID" })
        // }
        else {
            onSubmitButtonClick();
        }

    }

    const updateMapping = (e) => {
        loaderService.showLoader();
        apiClient
            .post(
                UPDATE_UNLOADER_MAPPING,
                {
                    "stakeholderType": stakeholderType,
                    "stakeholderUrn": stakeholderUrn,
                    "mappedUserEmailId": mappedUserEmailId,
                    "mappedUserRoleName": mappedUserRoleName,
                    "weighbridgeId": weighbridgeId
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                }
            )
            .then((response) => {
                setGetMappingResponse(response.data);
                setMappedUserEmailId('');
                setMappedUserRoleName('');
                setStakeholderType('');
                setStakeholderUrn('');
                setWeighbridgeId('');
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log("apiClientERROR", error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };


    useEffect(() => {
        if (getMappingResponse) {
            if (getMappingResponse.isSuccess === true) {
                toast.success(getMappingResponse?.message)
            }
            else {
                toast.error(getMappingResponse?.message ? getMappingResponse?.message : "Error")
            }
        }
    }, [getMappingResponse]);


    return (
        <>
            <Container maxWidth="xxl">
                {/* {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT88</p>} */}
                <Typography variant="h4" sx={{ mb: 2 }}>
                    <Fab onClick={() => { navigate(-1) }} size="small" aria-label="back" title='Back'>
                        <KeyboardArrowLeftRounded />
                    </Fab> WeighBridge Operator & Unloader Mapping
                </Typography>
                <Card>
                    <CardContent>
                        <Grid container spacing={1} direction="row" mt={1}>
                            <Grid item xs={12}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth size="small" required error={errorMessage.stakeholderTypeError}>
                                            <InputLabel>Stakeholder Type</InputLabel>
                                            <Select label="Stakeholder Type" name="stakeholderType" value={stakeholderType || ''} onChange={(e) => onTypeChange(e)}>
                                                <MenuItem value="LLE">LLE</MenuItem>
                                                {/*<MenuItem value="Interim Storage Operator">ISO</MenuItem>*/}
                                                <MenuItem value="Plant">Plant</MenuItem>
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.stakeholderTypeError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth size="small" required error={errorMessage.stakeholderUrnError}>
                                            <InputLabel>Stakeholder URN</InputLabel>
                                            <Select label="Stakeholder URN" value={stakeholderUrn || ''} name="stakeholderUrn" onChange={(e) => onUrnChange(e)}>
                                                {urnList &&
                                                    urnList?.map((items) => (
                                                        <MenuItem value={items.urn}>{items.urn}</MenuItem>

                                                    ))}
                                                {stakeholderType === "Plant" && <MenuItem value="ABEPL">ABEPL</MenuItem>}
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.stakeholderUrnError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth size="small" required error={errorMessage.mappedUserRoleNameError}>
                                            <InputLabel>Mapped User Role</InputLabel>
                                            <Select label="Stakeholder Type" name="mappedUserRoleName" value={mappedUserRoleName || ''} onChange={(e) => handleMappedRoleChange(e)}>
                                                <MenuItem value="PIT-WeighbridgeOperator">WeighBridge Operator</MenuItem>
                                                <MenuItem value="PIT-ManualWeighbridgeOperator">Manual WeighBridge Operator</MenuItem>
                                                <MenuItem value="PIT-Unloader">Unloader</MenuItem>
                                                <MenuItem value="PIT-Loader">Loader</MenuItem>
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.mappedUserRoleNameError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth size="small" required error={errorMessage.mappedUserEmailIdError}>
                                            <InputLabel>Mapped User Email</InputLabel>
                                            <Select label="Mapped User Email" value={mappedUserEmailId || ''} name="mappedUserEmailId" onChange={(e) => handleMappedUserEmailChange(e)}>
                                                {unloadersList &&
                                                    unloadersList?.map((items) => (
                                                        <MenuItem value={items.emailAddress}>{items.emailAddress}</MenuItem>

                                                    ))}
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.mappedUserEmailIdError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <FormControl fullWidth size="small" required error={errorMessage.mappedUserEmailIdError}>
                                            <InputLabel>WeighBridge ID</InputLabel>
                                            <Select label="WeighBridge ID" value={weighbridgeId || ''} name="weighbridgeId" onChange={(e) => onWeighBridgeIdChange(e)}>
                                                {weighbridgeIdList &&
                                                    weighbridgeIdList?.map((items) => (
                                                        <MenuItem value={items.weighbridgeId}>{items.weighbridgeId}</MenuItem>

                                                    ))}
                                            </Select>
                                            <FormHelperText sx={{ color: 'red' }}>{errorMessage.weighbridgeIdError}</FormHelperText>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                    <Button endIcon={<SubmitIcon/>} sx={{ minWidth: 100 }} variant="contained" onClick={(e) => onSubmit(e)}>Submit</Button>
                </Box>
            </Container>
            <ConfirmationPopover onOpen={logModalOpen} onConfirm={onConfirmSubmit} onClose={handleLogModalClose} action="Submit" />
        </>
    )
}